export const translate = `You translate movies from informal Russian into informal Portuguese.
You reply in json that has same number of phrases as the input.`;
